import axios from "axios";
import { db } from "./offlineDB";
import { env } from "../constants/env";

export const prefetchAuditSummaries = async (token) => {
  if (!navigator.onLine) return;

  try {
    const labs = await db.offlineLabs.toArray();

    for (const lab of labs) {
      const labId = lab.id;

      // Fetch all audit summaries for the lab
      const res = await axios.get(
        `${env.kataApiUrl}/api/certification/audit-summary`,
        {
          params: { labId },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const summaries = res.data; // array of audit summaries

      for (const summary of summaries) {
        const existing = await db.offlineAuditSummaries.get(summary._id);

        if (existing?.offline) {
          console.log(
            "[Prefetch] Skipped overwrite — local offline edits exist",
            summary._id
          );
          continue;
        }

        const offlineId =
          summary._id && typeof summary._id === "string"
            ? summary._id
            : `offline-${crypto.randomUUID()}`;

        await db.offlineAuditSummaries.put({
          ...summary,
          id: offlineId,
          labId,
          labName: summary.labName ?? lab.name,
          hpczLicense: summary.hpczLicense ?? lab.hpczLicense,
          offline: false,
          lastSynced: new Date().toISOString(),
          timestamp: Date.now(),
        });
      }
    }

    console.log("✅ Prefetch audit summaries complete");
  } catch (err) {
    console.error("❌ Prefetch audit summaries failed:", err.message);
  }
};